import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetClienteCpfService } from '@/http/get-cliente-cpf.service'
import type { TCliente } from '@/types/cliente'
import { clientePorCpfPropostaKeys } from '@/utils/cliente-query-keys'

export const useClientePorCpfProposta = (cpf: string, enabled?: boolean): UseQueryResult<TCliente, AxiosError> => {
  return useQuery({
    queryKey: clientePorCpfPropostaKeys.obter(cpf),
    queryFn: async () => new GetClienteCpfService().execute({ cpf }).then((res) => res.data),
    enabled,
  })
}
